import { getServerError } from "./get-server-error";
import { notifications } from "@edgetier/global-components";

/**
 * Show a server error as a toast message.
 * @param serverError Backend error.
 */
export const showServerError = (serverError: any) => {
    notifications.error(getServerError(serverError));
};
